export default __webpack_public_path__ + "static/media/avatar_8_2.465d33c9.png";